document.addEventListener("turbo:load", function() {
    $('#search_company').autocomplete({
        source: $('#search_company').data('autocomplete-source')
    })
});
